export default "/assets/images/mama-hero.png?b3d63fb3177f99ccd6ed0b1296a82eb8";